import { Injectable } from '@angular/core';
import { CadastroUsuario } from '../../entity/CadastroUsuario';
import { RestService } from './../rest.service';
import { URL_API } from 'src/app/tools/URL';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ERRO_DADOS_NAO_GRAVADOS } from 'src/app/tools/Mensagens';
import { AuthService } from '../autenticacao/auth.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CadastroService {
  cadastroUsuario = {} as CadastroUsuario;

  constructor(private rest: RestService, private http: HttpClient, private authService: AuthService) {
    this.cadastroUsuario = {} as CadastroUsuario;
  }

  buscarCep(cep: string) {
    return this.http.get(URL_API.PATH_VIA_CEP + cep + '/json/', { reportProgress: true });
  }

  buscarCBOs(textoPesquisa: string) {
    return this.rest.get(`/cbo/lista/` + textoPesquisa).pipe(
      catchError(this.handleError)
    );
  }

  salvar(obj: CadastroUsuario) {

    if (obj.id === null || obj.id === undefined) {

      return this.gravar(obj);

    } else if (this.authService.isUsuarioExternoLogado()) {

      return this.atualizar(obj);

    } else {

      return this.atualizarPorOperador(obj);

    }

  }

  private extrairMensagemErro(erro: any): string {
    if (!erro) {
      return '';
    }

    if (typeof erro === 'string') {
      return erro;
    }

    if (Array.isArray(erro)) {
      const mensagens = erro
        .map(item => this.extrairMensagemErro(item))
        .filter((mensagem: string) => mensagem && mensagem.trim().length > 0);

      return mensagens.join('\n');
    }

    if (typeof erro === 'object') {
      if (erro.mensagem) {
        return erro.mensagem;
      }

      if (erro.message) {
        return erro.message;
      }

      if (erro.error) {
        return this.extrairMensagemErro(erro.error);
      }

      if (erro.errors && Array.isArray(erro.errors)) {
        return erro.errors.join('\n');
      }
    }

    return '';
  }

  gravar(obj: CadastroUsuario) {
    return this.rest.post(`${URL_API.PATH_USUARIO}/salvar`, obj).pipe(
        catchError(err => {
          const mensagemErro = this.extrairMensagemErro(err.error);
          if (mensagemErro) {
            alert(mensagemErro);
          }
          return throwError(err);
        }));
  }

  atualizar(obj: CadastroUsuario) {
    return this.rest.put(`${URL_API.PATH_USUARIO}/salvar/${obj.id}`, obj).pipe(
      catchError(this.handleError)
    );
  }

  atualizarPorOperador(obj: CadastroUsuario) {
    return this.rest.put(`${URL_API.PATH_USUARIO}/operador/salvar/${obj.id}`, obj).pipe(
      catchError(this.handleError)
    );
  }

  atualizarDataNascimento(id: number, dataNascimento: string) {
    return this.rest.put(`${URL_API.PATH_USUARIO}/data-nascimento/${id}`, { dataNascimento });
  }

  handleError(error: HttpErrorResponse){
    console.log(error);
    window.alert(ERRO_DADOS_NAO_GRAVADOS);
    return throwError(ERRO_DADOS_NAO_GRAVADOS);
  }



  private readonly API_URL = 'https://servicodados.ibge.gov.br/api/v1/localidades';

  // Retorna todas os Países
  getPaises(): Observable<any> {
    return this.http.get(`${this.API_URL}/paises`);
  }

   // Retorna todas as UFs (Estados)
  getUfs(): Observable<any> {
    return this.http.get(`${this.API_URL}/estados`);
  }

  // Retorna os municípios de uma UF específica
  getMunicipios(ufId: string): Observable<any> {
    return this.http.get(`${this.API_URL}/estados/${ufId}/municipios`);
  }


}
